import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import MarketingHeader from "./MarketingHeader";
import MarketingFooter from "./MarketingFooter";

/**
 * Wraps every public marketing page with the white header + dark footer, and
 * scrolls to top whenever the user navigates between pages.
 */
export default function MarketingLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    document.title = "SRES";
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-900" data-testid="marketing-layout">
      <MarketingHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
}
